<sirius-container>
    @for (group of resolvedGroups(); track $index) {
        <div class="sir-list">
            @if (group.title) {
                <sirius-heading
                    [h]="4"
                    [textStyleSize]="listCount() === 1 ? 'm' : 's'"
                    [text]="group.title"
                ></sirius-heading>
            }
            <ul>
                @for (item of group.items; track $index) {
                    <li>
                        <sirius-checkmark [config]="item"></sirius-checkmark>
                    </li>
                }
            </ul>
        </div>
    }
</sirius-container>
